<template>
    <a :class="['t-card-course t-card-course__item', { _list: activeView }]" :href="item.link">
        <div class="t-card-course__wrap">
            <div class="t-card-course__img">
                <img v-if="item.img" class="t-object-fit-cover" :src="item.img" :alt="item.name">
                <photoPlug v-else></photoPlug>
                <svg v-if="item.img" class="t-card-course__play" width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_6372_9332)">
                        <path d="M26.8335 19.5L52.5002 36L26.8335 52.5V19.5Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <circle cx="36" cy="36" r="35.5" stroke="white" stroke-opacity="0.25"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_6372_9332">
                            <rect width="72" height="72" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </div>
            <div class="t-card-course__content">
                <div class="t-card-course__row _top">
                    <h3 class="t-card-course__title">{{ item.name }}</h3>
                    <svg
                        @click.stop.prevent="toggleFavorite(item)"
                        :class="['t-card-course__star', { _active: item.isFavorite }]"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0001 1.6001C16.4061 1.6001 16.7769 1.83057 16.9566 2.19463L20.8287 10.039L29.4877 11.3046C29.8894 11.3634 30.2229 11.645 30.3481 12.0311C30.4733 12.4172 30.3685 12.841 30.0777 13.1242L23.813 19.2261L25.2914 27.8465C25.3601 28.2467 25.1956 28.6511 24.867 28.8898C24.5385 29.1284 24.103 29.1598 23.7436 28.9708L16.0001 24.8986L8.25661 28.9708C7.89723 29.1598 7.46172 29.1284 7.13321 28.8898C6.8047 28.6511 6.64017 28.2467 6.70881 27.8465L8.1873 19.2261L1.92255 13.1242C1.63175 12.841 1.52693 12.4172 1.65213 12.0311C1.77734 11.645 2.11086 11.3634 2.51253 11.3046L11.1716 10.039L15.0436 2.19463C15.2233 1.83057 15.5941 1.6001 16.0001 1.6001Z" fill="#02B26E"/>
                    </svg>
                </div>
                <div class="t-card-course__row">
                    <p class="t-card-course__desc _decor" v-if="item.time">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 6.66667V10L12.5 12.5M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z" stroke="#C0C0CC" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>{{ item.time }}</span>
                    </p>
                    <p class="t-card-course__desc" v-if="item.files">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.66634 5.83333V12.5C6.66634 12.942 6.84194 13.366 7.1545 13.6785C7.46706 13.9911 7.89098 14.1667 8.33301 14.1667H13.333M6.66634 5.83333V4.16667C6.66634 3.72464 6.84194 3.30072 7.1545 2.98816C7.46706 2.67559 7.89098 2.5 8.33301 2.5H12.1547C12.3757 2.50005 12.5876 2.58788 12.7438 2.74417L16.4222 6.4225C16.5785 6.57874 16.6663 6.79067 16.6663 7.01167V12.5C16.6663 12.942 16.4907 13.366 16.1782 13.6785C15.8656 13.9911 15.4417 14.1667 14.9997 14.1667H13.333M6.66634 5.83333H4.99967C4.55765 5.83333 4.13372 6.00893 3.82116 6.32149C3.5086 6.63405 3.33301 7.05797 3.33301 7.5V15.8333C3.33301 16.2754 3.5086 16.6993 3.82116 17.0118C4.13372 17.3244 4.55765 17.5 4.99967 17.5H11.6663C12.1084 17.5 12.5323 17.3244 12.8449 17.0118C13.1574 16.6993 13.333 16.2754 13.333 15.8333V14.1667" stroke="#C0C0CC" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span>{{ item.files }}</span>
                    </p>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import Vue from "vue";
import photoPlug from "@components/ui-components/photo-plug/photo-plug";

export default {
    name: 'card-course',
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        activeView: {
            type: Boolean,
            default: false
        }
    },
    components: {
        photoPlug
    },
    methods: {
        toggleFavorite(item) {
            let url = 'lk/materials-online-courses/addFavorite';

            if (item.isFavorite) {
                url = 'lk/materials-online-courses/removeFavorite';
            }

            let fd = new FormData();
            fd.append('id', item.id);

            Vue.http.post(url, fd)
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        this.$emit('toggleFavorites', { id: item.id, isFavorite: !item.isFavorite });
                    }
                })
                .catch(() => {});
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/templates/components/ui-components/card-course/card-course.vue